module.exports = __webpack_public_path__ + "static/media/logov-01.b2080a78.svg";